<template>
  <vs-chip v-if="status" :class="statusModifier.label + ' text-white'">
    {{statusModifier.text }}
  </vs-chip>
</template>

<script>
import {
  STATUS_NOT_REGISTERED,
  STATUS_REGISTERED,
  STATUS_FINISHED,
  STATUS_CANCELED,
  STATUS_EXPIRED
} from "@/const/booking-service";

export default {
  props: {
    status: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      statusList: [
        {
          comparison: STATUS_NOT_REGISTERED,
          label: 'vs-chip-primary',
          text: 'Belum Teregister',
        },
        {
          comparison: STATUS_REGISTERED,
          label: 'vs-chip-primary',
          text: 'Teregister',
        },
        {
          comparison: STATUS_FINISHED,
          label: 'vs-chip-success',
          text: 'Selesai',
        },
        {
          comparison: STATUS_CANCELED,
          label: 'vs-chip-danger',
          text: 'Dibatalkan',
        },
        {
          comparison: STATUS_EXPIRED,
          label: 'vs-chip-danger',
          text: 'Kadaluarsa',
        },
      ]
    };
  },
  computed: {
    statusModifier() {
      return this.statusList.find(({ comparison }) => {
        return comparison == this.status;
      });
    }
  }
};
</script>
